import { render, staticRenderFns } from "./InscriptionView.vue?vue&type=template&id=4838ba0b&scoped=true"
import script from "./InscriptionView.vue?vue&type=script&lang=js"
export * from "./InscriptionView.vue?vue&type=script&lang=js"
import style0 from "./InscriptionView.vue?vue&type=style&index=0&id=4838ba0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4838ba0b",
  null
  
)

export default component.exports